module.exports = __webpack_public_path__ + "static/media/notification.a2050abb.mp3";